export default __webpack_public_path__ + "static/media/A1.50893dec.jpg";